import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GetStagesService {
  getStages(): string | null {
    let stages: any = localStorage.getItem('stages');
    stages = JSON.parse(stages);
    return stages;
  }
}
